import React, { useState } from "react";

function App() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [statusMsg, setStatusMsg] = useState("");

    async function handleLogin(e) {
        e.preventDefault();
        try {
            const res = await fetch("https://alaqtar-api.visengine.app/auth/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });
            if (!res.ok) throw new Error("Login failed");
            const data = await res.json();
            setToken(data.access_token);
            setStatusMsg("Logged in successfully");
        } catch (err) {
            console.error(err);
            setStatusMsg("Login failed");
        }
    }

    async function fetchMe() {
        try {
            const res = await fetch("https://alaqtar-api.visengine.app/users/me", {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (!res.ok) throw new Error("Failed to fetch user");
            const data = await res.json();
            setUser(data);
        } catch (err) {
            console.error(err);
            setStatusMsg("Failed to fetch user");
        }
    }

    async function updateBlock(blockId, status) {
        try {
            const res = await fetch(`https://alaqtar-api.visengine.app/blocks/${blockId}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ status }),
            });
            if (!res.ok) throw new Error("Update failed");
            const data = await res.json();
            setStatusMsg(`Block updated: ${JSON.stringify(data)}`);
        } catch (err) {
            console.error(err);
            setStatusMsg("Failed to update block");
        }
    }

    return (
        <div className="p-6 max-w-md mx-auto">
            <h1 className="text-xl font-bold mb-4">Example</h1>

            {!token ? (
                <form onSubmit={handleLogin} className="space-y-3">
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="border p-2 w-full"
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="border p-2 w-full"
                    />
                    <button
                        type="submit"
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                    >
                        Login
                    </button>
                </form>
            ) : (
                <div className="space-y-4">
                    <button
                        onClick={fetchMe}
                        className="bg-green-500 text-white px-4 py-2 rounded"
                    >
                        Get My Info
                    </button>

                    <button
                        onClick={() => updateBlock(42, "available")}
                        className="bg-purple-500 text-white px-4 py-2 rounded"
                    >
                        Update Block #42 → available
                    </button>

                    {user && (
                        <div className="border p-3 rounded">
                            <h2 className="font-bold">User Info:</h2>
                            <pre>{JSON.stringify(user, null, 2)}</pre>
                        </div>
                    )}
                </div>
            )}

            {statusMsg && <p className="mt-4 text-sm">{statusMsg}</p>}
        </div>
    );
}

export default App;
